(() => {
  const pendingIds = new Set();
  function apply() {
    document.querySelectorAll('[data-no-quantity-product]').forEach(node => {
      const data = JSON.parse(node.textContent);
      const section = document.getElementById('MainProduct-' + node.dataset.sectionId);
      if (!section) return;
      const ids = new Set(data.variants.map(v => String(v.id)));
      const productLocked = (window.VelveleCart.current.items || []).some(item => ids.has(String(item.variant_id))) ||
        [...pendingIds].some(id => ids.has(id));
      const tuplePilot = !!section.querySelector('vv-software-pilot');
      section.querySelectorAll('.product-form__submit[data-no-quantity="true"]').forEach(button => {
        const variantId = button.closest('form')?.querySelector('[name="id"]')?.value;
        const variant = data.variants.find(v => String(v.id) === variantId);
        const locked = tuplePilot
          ? (window.VelveleCart.current.items || []).some(item => String(item.variant_id) === variantId) || pendingIds.has(variantId)
          : productLocked;
        const wasLocked = button.classList.contains('is-disabled-noqty');
        const label = button.querySelector('.button__label') || button.querySelector('span');
        button.classList.toggle('is-disabled-noqty', locked);
        if (locked) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          if (label) { label.textContent = 'Already in cart'; label.dataset.label = label.textContent; }
        } else if (wasLocked) {
          const unavailable = !variant?.available || button.dataset.variantUnavailable === 'true';
          button.disabled = unavailable;
          button.classList.remove('is-disabled');
          if (!button.classList.contains('loading')) button.removeAttribute('aria-disabled');
          if (label) {
            label.textContent = unavailable ? window.variantStrings.soldOut : (button.dataset.defaultLabel || window.variantStrings.addToCart);
            label.dataset.label = label.textContent;
          }
        }
      });
    });
  }
  document.addEventListener('variant:add', event => {
    if (event.detail?.variant?.id) pendingIds.add(String(event.detail.variant.id));
    apply();
  });
  document.addEventListener('cart:change', event => {
    const cart = event.detail?.cart || event.detail;
    if (Array.isArray(cart?.items) && typeof cart.item_count === 'number') pendingIds.clear();
    apply();
  });
  ['variant:change', 'shopify:section:load'].forEach(name => document.addEventListener(name, apply));
  apply();
})();
